<template>
   <span class="country">
      <span v-html="icon" :title="country_name" class="country__flag"></span>
      <span v-if="country_name && !flag" class="country__name">{{country_name}}</span>
   </span>
</template>

<script>
   import { byAlpha2 } from 'iso-country-codes'

   // Override names here
   byAlpha2['GB']['name'] = 'United Kingdom'
   byAlpha2['US']['name'] = 'United States of America'

   export default {
      props: {
         code: { type: String, default: 'gb' },
         flag: { type: Boolean, default: false }
      },
      computed: {
         iso_lower() {
            const code = this.code == null ? 'unknown' : this.code
            return code.toLowerCase()
         },
         icon() {
            let icon = this.getFlagImg(this.iso_lower, true)
            return icon
         },
         country_name() {
            const country = byAlpha2[this.iso_lower.toUpperCase()]
            return country ? country['name'] : null
         },
      },
   }
</script>

<style lang="scss" scoped>
   @import '~/assets/SCSS/Base/00_functions.scss';
   @import '~/assets/SCSS/Base/01_variables.scss';
   @import '~/assets/SCSS/Base/02_mixins.scss';

   @import '~/assets/SCSS/Vana/flag.scss';
</style>